import { useConfigParam } from '../hooks/config'
export const useFacebookLink = (): string => useConfigParam('contact_fb_lnk')
